import { useState }   from "react";
import useSWRInfinite from "swr/infinite";

import useFetchList from "../categoryPage/useFetchList";

import Presentation from "./presentation";

const MobileContainer = ( { data: initialData, tabsList } ) => {
	const [ activeTab, setActiveTab ] = useState ( initialData[0]?.id?.toString () );
	const [ list, setList ]           = useState ( initialData[0]?.sessions || [] );
	const [ data, setData ]           = useState ( initialData[0] || [] );

	const { __data, fetchMore, isEmpty, isLoadingMore } = useFetchList ( { data } );

	const onChangeTab = tabId => {
		const activeTabData = initialData.find ( item => item?.id === Number ( tabId ) );

		setList ( activeTabData?.sessions );
		setActiveTab ( activeTabData.cardName );
		setData ( activeTabData );
	};

	return (
		<Presentation
			activeTab   = { activeTab }
			data        = { [ ...list, ...__data ] }
			fetchMore = { fetchMore }
			isEmpty = { isEmpty }
			isLoadingMore = { isLoadingMore }
			onChangeTab = { onChangeTab }
			tabsList    = { tabsList }
		/>

	);
};

export default MobileContainer;